import { PkgWarehouse } from '@/api/user-package/types/UserPkg'
import AedIcon from '@/components/icons/aed.svg?react'
import EurIcon from '@/components/icons/eur.svg?react'
import GbpIcon from '@/components/icons/gbp.svg?react'
import UsdIcon from '@/components/icons/usd.svg?react'
export const warehouseToCurrencyLabel = {
  [PkgWarehouse.GR]: 'EUR',
  [PkgWarehouse.USA]: 'USD',
  [PkgWarehouse.UK]: 'GBP',
  [PkgWarehouse.UAE]: 'AED',
}
const warehouseToCurrencyIcon = {
  [PkgWarehouse.GR]: EurIcon,
  [PkgWarehouse.USA]: UsdIcon,
  [PkgWarehouse.UK]: GbpIcon,
  [PkgWarehouse.UAE]: AedIcon,
}
interface Props {
  warehouse: PkgWarehouse
  className?: string
}
export const CurrencyPreview = ({ warehouse, className }: Props) => {
  const Icon = warehouseToCurrencyIcon[warehouse]
  return <Icon className={className} />
}
